import { CostCenter } from '@ironsight/types'

export function getSuggestedCostCenters(
  costCentersForHub: CostCenter[],
  pickupLocationIds: number[],
  destinationLocationId?: number | null,
  divisionId?: number | null,
) {
  return costCentersForHub
    .filter((costCenter) => {
      const hasLocations = costCenter.locationIds.size > 0
      const hasDivisions = costCenter.divisionIds.size > 0

      // Early exit for empty cost centers
      if (!hasLocations && !hasDivisions) return false
      if (!divisionId && pickupLocationIds.length === 0 && !destinationLocationId) return false

      const matchesPickupLocations = pickupLocationIds.some((s) => costCenter.locationIds.has(s))
      const matchesDestination =
        destinationLocationId && costCenter.locationIds.has(destinationLocationId)
      const matchesDivision = divisionId && costCenter.divisionIds.has(divisionId)

      if (!hasDivisions) return matchesPickupLocations || matchesDestination
      if (!hasLocations) return matchesDivision

      return matchesDivision && (matchesPickupLocations || matchesDestination)
    })
    .map((costCenter) => {
      const linkedWith: string[] = []

      if (divisionId && costCenter.divisionIds.has(divisionId)) linkedWith.push('division')
      if (pickupLocationIds.some((s) => costCenter.locationIds.has(s)))
        linkedWith.push('pick up location')
      if (destinationLocationId && costCenter.locationIds.has(destinationLocationId))
        linkedWith.push('destination')

      const linkedWithString =
        linkedWith.length === 1
          ? `(Linked with ${linkedWith[0]})`
          : `(Linked with ${linkedWith.slice(0, -1).join(', ')} and ${
              linkedWith[linkedWith.length - 1]
            })`

      return {
        label: costCenter.label,
        labelWithLinkedInfo: `${costCenter.label} ${linkedWithString}`,
        description: costCenter.description,
      }
    })
}
